<script setup lang="ts">
import type { HeroContent } from '@/client/types';
import { Button } from '@/components/ui/button';

defineProps<{
    id: string;
    content: HeroContent;
    ctaHref?: string | null;
}>();
</script>

<template>
    <section :id="id" class="py-12 md:py-20">
        <div :class="['mx-auto grid max-w-6xl items-center gap-10 px-4', content.image ? 'md:grid-cols-2' : 'text-center']">
            <div :class="['grid gap-6', { 'mx-auto max-w-3xl justify-items-center': !content.image }]">
                <h1 v-if="content.title" class="text-4xl font-semibold tracking-tight md:text-6xl">{{ content.title }}</h1>
                <p v-if="content.subtitle" class="text-lg whitespace-pre-line text-muted-foreground md:text-xl">{{ content.subtitle }}</p>
                <div v-if="ctaHref">
                    <Button size="lg" as-child>
                        <a :href="ctaHref">{{ content.button_label || $t('site.leave_request') }}</a>
                    </Button>
                </div>
            </div>
            <img
                v-if="content.image"
                :src="content.image"
                :alt="content.title ?? ''"
                class="aspect-video w-full rounded-2xl object-cover"
                fetchpriority="high"
            />
        </div>
    </section>
</template>
